export const POSITION_TYPE = {
    LITE: 'lite',
    PRO: 'pro'
}

export const WEB_PLATFORM_TYPE = {
    ANDROID : 0,
    IOS : 1,
    OTHER : 9999
}

export const PUSH_ACTION = {
    MY_LOCATION : '1',
    SOCCERHOW_MAIN : '2',
    SOCCERJOIN_MAIN : '3',
    MY_PAGE : '4',
    POSITION_SEARCH : '5',
    ONE_ON_ON_ASK : '6',
    WEB_LINK : '7',
    NOTICE_DETAIL : '8',
    BRANCH_DETAIL : '9',
    COACH_DETAIL : '10',
    LADING_PAGE : '11',
    POSITION_PRO : '12',
    MAKE_JOIN : '13',
    MERCENARY_SETTING : '14',
    MERCENARY : '15',
    SELECT_POSITION_FIND : '16',
    MAKE_MERCENARY_SCHEDULE : '17',
    SOCCERHOW_TAB_SOCCERHOW : '18',
    NOTICE_EVENT_DETAIL : '19',
    HOME_LEARN : '20',
    HOME_JOIN : '21',
    TRAINING_MAIN : '22',
    MYCHAT : '23',
    MESSAGE : '24',
    CHATTING : '30',
    SPORTLIGHT_LIST : '31',
    SPORTLIGHT_DETAIL : '32',
    TEAM_DETAIL : '33',

    SOCCERHOW_DETAIL : '1000',
    COMMUNITY_DETAIL : '1001',
    JOIN_DETAIL : '1002',
    JOIN_SCHEDULE_DETAIL : '1003',
    JOIN_TALK : '1004',
    COMMUNITY_MAIN : '1005',
    MEMBER_EVALUATION : '1006',
    MEMBER_EVALUATION_RESULT : '1007',
    PROFILE : '1008',
    REPORT_DETAIL : '1009',
    MERCENARY_SCHEDULE_DETAIL : '1010',
    JOIN_INVITATION_LIST : '1011',

    OPEN_SCHEDULE_DETAIL : '1012',
    LESSON_SCHEDULE_DETAIL : '1013',
    OPEN_TALK : '1014',
    POSITION_DELAY : '1015',
    WEB_NOWPAGE : '1016',

    SOCCERHOW_REQUEST_DETAIL : '1020',
    SOCCERHOW_TRAINING_DETAIL : '1021',
    DIRECT_MESSAGE_LIST : '1022',

    MERCENARY_REQUEST_RECEIVED : '1101',
    MERCENARY_PROPOSE_RECEIVED : '1102',
    MERCENARY_REQUEST_STATUS_CHANGED : '1103',
    MERCENARY_PROPOSE_STATUS_CHANGED : '1104',

    MERCENARY_SCHEDULE_MINE : '1105',
}

export const initialRouteStr = '/view/home';